<script setup lang="ts">
import ProgressSpinner from 'primevue/progressspinner'
import { carregando } from '@/plugins/loading'
</script>

<template>
  <!-- Overlay global de carregamento (equivale ao dialog "Aguarde Processamento" do legado). -->
  <Transition name="loading-fade">
    <div v-if="carregando" class="loading-overlay" role="status" aria-live="polite" aria-busy="true">
      <div class="loading-box">
        <ProgressSpinner
          style="width: 56px; height: 56px"
          strokeWidth="4"
          animationDuration="1s"
          aria-label="Carregando"
        />
        <span class="loading-text">Aguarde...</span>
      </div>
    </div>
  </Transition>
</template>

<style scoped>
.loading-overlay {
  position: fixed;
  inset: 0;
  z-index: 11000; /* acima de dialogs/menus */
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.35);
}

.loading-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.75rem;
  padding: 1.5rem 2rem;
  border-radius: 12px;
  background: var(--surface-0, #ffffff);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.25);
}

.loading-text {
  font-weight: 600;
  color: var(--text-color, #334155);
}

.loading-fade-enter-active,
.loading-fade-leave-active {
  transition: opacity 0.15s ease;
}
.loading-fade-enter-from,
.loading-fade-leave-to {
  opacity: 0;
}
</style>
